import { useI18n } from "@core/i18n/i18n";

import styled from "@emotion/styled";
import { CountryFlag } from "@ui/components/common/country-flag";
import { isNotNil } from "@utils/assert";
import { countries } from "countries-list";
import { Dropdown, DropdownProps } from "primereact/dropdown";
import React from "react";

interface CountryInputProps
	extends Omit<DropdownProps, "options" | "optionLabel" | "optionValue" | "valueTemplate" | "itemTemplate"> {
	error?: boolean;
	countryCodes: string[];
}

export const CountryInput = ({ error = false, countryCodes, ...otherProps }: CountryInputProps): JSX.Element => {
	const { format } = useI18n();

	return (
		<Dropdown
			{...otherProps}
			className={error ? "p-invalid" : undefined}
			options={countryCodes}
			emptyMessage={format("register.countrySelection.countryDropdown.emptyMessage")}
			valueTemplate={CountryOptionTemplate}
			itemTemplate={CountryOptionTemplate}
		/>
	);
};

export const GET_COUNTRY_NAME = (countryCode: string): string | undefined =>
	countries[countryCode.toUpperCase() as keyof typeof countries].native;

const CountryOptionTemplate = (countryCode: string | undefined): JSX.Element => {
	const { format } = useI18n();

	return (
		<DropdownItemContainer>
			{isNotNil(countryCode) ? (
				<>
					<StyledCountryFlag code={countryCode.toUpperCase()} />
					<div>{GET_COUNTRY_NAME(countryCode)}</div>
				</>
			) : (
				<p>{format("global.form.dropdown.placeholder")}</p>
			)}
		</DropdownItemContainer>
	);
};

const DropdownItemContainer = styled.div`
	display: flex;
	place-items: center;
	gap: 0.75em;
`;

const StyledCountryFlag = styled(CountryFlag)`
	height: 1em;
	width: 1.5em;
	border-radius: 2px;
`;
